// extracted by mini-css-extract-plugin
module.exports = {"modal":"TipsPopup_modal__zXaGa","text":"TipsPopup_text__SZSb0","btn":"TipsPopup_btn__3Uz1w","sub-title":"TipsPopup_sub-title__1eDWI"};